import { render, staticRenderFns } from "./SubscriberProducts.vue?vue&type=template&id=fd239960&"
import script from "./SubscriberProducts.vue?vue&type=script&lang=js&"
export * from "./SubscriberProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports